import { CSSProperties, ReactNode, FunctionComponent } from 'react';
import { withStyles } from 'vopay';
import styles from './DetailRow.module.scss';

const cn = withStyles(styles);

type DetailRowProps = {
  label: ReactNode;
  value: ReactNode;
  style?: CSSProperties;
};

const DetailRow: FunctionComponent<DetailRowProps> = ({ label, value, style }) => (
  <div className={cn('row')} style={style}>
    <span className={cn('label')}>{label}</span>
    <span className={cn('value')}>{value}</span>
  </div>
);

export default DetailRow;
